import React, { useMemo } from 'react';
import { useAuthContext } from './AuthContextProvider';
import { DataContext, useDataContext } from './DataContextProvider';
import { createFieldMap, createFieldMapType } from './useEntities';

export const AvDataContextWithExternalProjectionsProvider = ({ children }) => {
  const { accountEntities, ...rest } = useDataContext();
  const value = useMemo(
    () => ({
      ...rest,
      accountEntities: {
        ...accountEntities,
        aggProjs: { ...accountEntities.aggProjs, ...accountEntities.externalProjs },
        fieldMap: { ...accountEntities.fieldMap, ...createFieldMap(accountEntities.externalProjs) },
        fieldTypeMap: { ...accountEntities.fieldTypeMap, ...createFieldMapType(accountEntities.externalProjs) },
      },
    }),
    [accountEntities, rest]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useAvContext = () => {
  const authContext = useAuthContext();
  const dataContext = useDataContext();

  return useMemo(
    () => ({
      ...authContext,
      ...dataContext,
      isLoading: authContext.isLoading || dataContext.isLoading,
    }),
    [authContext, dataContext]
  );
};
